import { supabase } from './client';
import { supabaseUrl, supabaseAnonKey } from './config';
import { MENU_IMPORT_MAX_BYTES, MENU_IMPORT_MIME_TYPES, validateMenuImportFile, validateReviewedMenuImport } from './edge-functions/_shared/menuImport';

export async function extractMenuDraft(menuId, file, { signal } = {}) {
  if (!file || !MENU_IMPORT_MIME_TYPES.includes(file.type) || file.size > MENU_IMPORT_MAX_BYTES || file.size === 0) {
    throw new Error('Selecciona un PDF, JPG, PNG o WebP de hasta 8 MB.');
  }
  validateMenuImportFile(new Uint8Array(await file.arrayBuffer()), file.type);
  const { data, error } = await supabase.auth.getSession();
  if (error || !data?.session?.access_token) throw new Error('Inicia sesion nuevamente antes de importar.');
  const body = new FormData(); body.append('file', file);
  const response = await fetch(`${supabaseUrl}/functions/v1/menu-import-extract?menuId=${encodeURIComponent(menuId)}`, {
    method: 'POST', signal, body,
    headers: { Authorization: `Bearer ${data.session.access_token}`, apikey: supabaseAnonKey },
  });
  const result = await response.json().catch(() => null);
  if (!response.ok || !Array.isArray(result?.items)) throw new Error(result?.error || 'No pudimos leer la carta. No se creo ningun plato.');
  return result;
}

export async function importReviewedMenu(menuId, requestId, items) {
  const payload = validateReviewedMenuImport(items);
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 30000);
  let response;
  try {
    response = await supabase.rpc('import_reviewed_menu', {
      p_menu_id: menuId, p_request_id: requestId, p_items: payload,
    }).abortSignal(controller.signal);
  } finally { clearTimeout(timeout); }
  const { data, error } = response;
  if (error) {
    const failure = new Error(error.code === '42501' ? 'No tenes permiso para guardar esta carta.'
      : 'No pudimos confirmar el guardado. Reintenta esta misma confirmacion: no se duplicaran los platos.');
    failure.retryable = !error.code || !['42501', 'P0001', '22023', '23514', 'PGRST202'].includes(error.code);
    if (!failure.retryable && error.code === 'P0001') failure.message = error.message;
    if (error.code === 'PGRST202') failure.message = 'La importacion todavia no esta habilitada en este entorno.';
    throw failure;
  }
  if (!Array.isArray(data?.created) || !Array.isArray(data?.skipped)) throw new Error('Falta confirmar el resultado. Reintenta la misma confirmacion.');
  return data;
}
